"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Award = void 0;
const common_1 = require("../common");
const hooks_1 = require("../common/hooks");
const client_1 = require("./client");
class Award {
    /**
     * Creates an instance of Award.
     * @param {AwardAddresses} addresses
     * @param {AwardInfo} award
     * @param {AssociatedToken} vault
     * @memberof Award
     */
    constructor(addresses, award, vault) {
        this.addresses = addresses;
        this.award = award;
        this.vault = vault;
    }
    /**
     * Derive the award account and vault token account PDAs
     *
     * @static
     * @param {PublicKey} stakeAccount
     * @param {string} seed
     * @returns {AwardAddresses}
     * @memberof Award
     */
    static derive(stakeAccount, seed) {
        const award = (0, common_1.findDerivedAccount)(client_1.RewardsClient.PROGRAM_ID, "award", stakeAccount, seed);
        const vault = (0, common_1.findDerivedAccount)(client_1.RewardsClient.PROGRAM_ID, award, "vault");
        return { award, vault };
    }
    /**
     * Load the award account and its vault
     *
     * @static
     * @param {Program<RewardsIdl>} rewardsProgram
     * @param {PublicKey} stakeAccount
     * @param {string} seed
     * @returns {Promise<Award>}
     * @memberof Award
     */
    static async load(rewardsProgram, stakeAccount, seed) {
        const addresses = this.derive(stakeAccount, seed);
        const award = (await rewardsProgram.account.award.fetch(addresses.award));
        const vault = await common_1.AssociatedToken.loadAux(rewardsProgram.provider.connection, addresses.vault);
        if (!vault) {
            throw new Error("Vault is undefined");
        }
        return new Award(addresses, award, vault);
    }
    /**
     * React hook to use the award account and its vault
     *
     * @static
     * @param {(Program<RewardsIdl> | undefined)} rewardsProgram
     * @param {(PublicKey | undefined)} stakeAccount
     * @param {string} seed
     * @returns {(Award | undefined)}
     * @memberof Award
     */
    static use(rewardsProgram, stakeAccount, seed) {
        return hooks_1.Hooks.usePromise(async () => rewardsProgram && stakeAccount && Award.load(rewardsProgram, stakeAccount, seed), [rewardsProgram, stakeAccount, seed]);
    }
}
exports.Award = Award;
//# sourceMappingURL=award.js.map